import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  FileMarkdownOutlined,
  HistoryOutlined,
  HomeOutlined,
  LogoutOutlined,
  MessageOutlined,
  PayCircleOutlined,
  ReadOutlined,
  ScheduleOutlined,
  ToolOutlined,
  UserOutlined,
} from '@ant-design/icons';
import styles from "./MonkLayout.module.css"
import { Avatar, Layout, Menu, Space } from 'antd';
import Header from "../../Components/Header";
import { GetAccountByID } from "../../api/AdminService";
const { Sider, Footer, Content } = Layout;



export default function MonkLayout() {
  const navigate = useNavigate(); 
  const location = useLocation();
  const userID = JSON.parse(localStorage.getItem('id'));
  const [user, setUser] = useState(null);
  const logout = () => {
    localStorage.clear();
    navigate('/');
  };
  const GetUser = (id) => {
    GetAccountByID(id).then(res => {
      setUser(res.data);
      console.log(res.data);
    })
  }
  useEffect(() => {
    GetUser(userID);
  }, []);
  const items = [

    {
      key: '/Monk/Schedule',
      icon: <ScheduleOutlined />,
      label: 'Schedule',
    },
    {
      key: '/Monk/MenuFood',
      icon: <ScheduleOutlined />,
      label: 'Menufood',
    },
    {
      key: '/Monk/Dish',
      icon: <ScheduleOutlined />,
      label: 'Dish',
    },
    {
      key: "/Monk/chat",
      icon: <MessageOutlined />,
      label: 'Chat',
    },
    {
      key: '/',
      icon: <LogoutOutlined />,
      label: 'Log Out',
      onClick: () => logout()

    },
  ];

  const getSelectedKey = (pathname) => {
    return items.find(item => item.key === pathname)?.key || '';
  };

  return (
    <>
      <Layout>
        {/* <Layout>
          <Header/>
        </Layout> */}

        <Layout>
          <Sider
            className={styles.siderStyle}
            style={{
              backgroundColor: 'white',
              position: 'fixed',
              height: '100vh',
              left: 0,
              overflow: 'auto'
            }}
            width={300}
          >
            <div style={{
              justifyContent: 'center',
              alignContent: 'center'
            }}>
              <div style={{ textAlign: 'center', position:'relative' }}>
              <div style={{color: 'blue', fontSize: '40px'}}>MCSM</div>
                <Space style={{ cursor: 'pointer', marginTop:23}}>
                  {user?.avatar ? 
                  <Avatar size={40} src={user?.avatar}/> 
                  : <Avatar size={40}
                    src={'https://firebasestorage.googleapis.com/v0/b/mcsm-fa24se115.appspot.com/o/images%2Ffa5e6491-7129-42e1-bdce-e92d067454c3?alt=media'} />}
                
                </Space>
                <div> {user?.firstName} {user?.lastName} </div>
                <div> {user?.role} </div>
                
              </div>
            </div> 
            <div>
            <Menu
              onClick={({ key }) => {
                navigate(key);
              }}
              mode='inline'
              selectedKeys={[getSelectedKey(location.pathname)]}
              items={items}
              style={{ fontSize: '20px', width: '100%', fontWeight: 'lighter' }}
            />
            </div>
          </Sider>

          <Layout style={{ marginLeft: 300 }}>
            <Content
              style={{
                margin: '24px 16px 0',
              }}
            >
              <Outlet />
            </Content>
          </Layout>

        </Layout>
      </Layout>
    </>
  );
}